<template>
    <div>
        <div v-loading="virt_is_loading" class="table-responsive">
            <div class="card-title ml-2">Виртуальные расходы <button v-if="$hasPermission('operations.create')" @click="showCreate()" class="btn btn-link text-success p-0" style="line-height: 1"><i class="fas fa-plus"></i></button></div>
            <table class="table table-sm table-striped">
                <thead>
                <th></th>
                <th style="width: 220px">Статья расходов</th>
                <th style="width: 150px">Сумма</th>
                <th class="text-nowrap">Дата</th>
                <th class="text-nowrap">Комментарий</th>
                <th class="text-nowrap">Пользователь</th>
                <th class="border-left"></th>
                </thead>
                <tbody>
                <VirtualOperationForm v-if="form_create_state" :obj="form_obj" @created="onCreated" @cancel="form_create_state = false" />
                <template v-for="item in virt_operations">
                    <tr v-if="!form_edit_state || form_edit_id !== item.id">
                        <template v-if="+item.platform_id === +car_platform_id">
                            <td class="text-nowrap"><PlatformIcon :id="item.platform_id" /></td>
                            <td class="text-nowrap">{{ item.category }}</td>
                            <td class="text-nowrap">{{ (item.amount / 100) | formatNumber }}</td>
                            <td class="text-nowrap">{{ item.created_at }}</td>
                            <td class="text-nowrap small text-muted">{{ item.comment }}</td>
                            <td class="text-nowrap">{{ item.creator_name }}</td>
                            <td class="table-light border-left text-right text-nowrap">
                                <button v-if="$hasPermission('operations.update')" @click="showEdit(item.id)" class="btn btn-sm btn-light"><i class="fas fa-pen"></i></button>
                                <el-popconfirm v-if="$hasPermission('operations.delete')"
                                               confirm-button-text='Да'
                                               cancel-button-text='Отмена'
                                               icon="el-icon-info"
                                               icon-color="red"
                                               title="Уверены что хотите вирт. расход?"
                                               @confirm="deleteVirtualOperation(item.id)"
                                >
                                    <button slot="reference" class="btn btn-sm btn-light"><i class="fas fa-times text-danger"></i></button>
                                </el-popconfirm>
                            </td>
                        </template>
                        <template v-else>
                            <td class="text-nowrap"><PlatformIcon :id="item.platform_id" /></td>
                            <td class="text-nowrap small text-muted">{{ item.category }}</td>
                            <td class="text-nowrap small text-muted">{{ (item.amount / 100) | formatNumber }}</td>
                            <td class="text-nowrap small text-muted">{{ item.created_at }}</td>
                            <td class="text-nowrap small text-muted">{{ item.comment }}</td>
                            <td class="text-nowrap small text-muted">{{ item.creator_name }}</td>
                            <td></td>
                        </template>
                    </tr>
                    <VirtualOperationForm v-else :obj="form_obj" @updated="onUpdated" @cancel="form_edit_state = false" />
                </template>
                </tbody>
            </table>
        </div>

        <div v-loading="operations_is_loading">
            <div class="card-title ml-2 mt-4">Операции по машине</div>
            <div class="table-responsive">
                <table class="table table-sm table-striped">
                    <thead>
                    <th class="text-nowrap">Статья</th>
                    <th class="text-nowrap">Юрлицо</th>
                    <th class="text-nowrap">Контрагент</th>
                    <th class="text-nowrap">Документ</th>
                    <th class="text-nowrap">Площадка</th>
                    <th class="text-nowrap">Дата</th>
                    <th class="text-nowrap">Актив</th>
                    <th class="text-nowrap">Пассив</th>
                    <th class="text-nowrap">Комментарий</th>
                    </thead>
                    <tbody>
                    <tr v-for="item in operations">
                        <td class="text-nowrap">{{ item.category }}</td>
                        <td class="text-nowrap">{{ item.salon_legal_entity ? item.salon_legal_entity.name : ''}}</td>
                        <td class="text-nowrap">{{ item.counteragent_name }}</td>
                        <td class="text-nowrap">{{ item.document_number }}</td>
                        <td class="text-nowrap">{{ item.platform.name }}</td>
                        <td class="text-nowrap">{{ item.document_date }}</td>
                        <td class="text-nowrap">{{ (item.direction === 'active' ? item.amount / 100 : 0) | formatNumber}} </td>
                        <td class="text-nowrap">{{ (item.direction === 'passive' ? item.amount / 100 : 0) | formatNumber}}</td>
                        <td class="text-nowrap">{{ item.comment }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import VirtualOperationForm from "./Operations/VirtualOperationForm";
import OperationCategoryData from "../../plugins/operation_category_data";
import PlatformIcon from "../platforms/PlatformIcon";
export default {
    name: "CarOperationsBlock",
    components: {PlatformIcon, VirtualOperationForm},
    props: {
        car_id: {
            type: Number,
            required: true,
        },
        car_platform_id: {
            type: Number,
            required: true,
        },
    },
    data: () => ({
        form_edit_id: null,
        form_edit_state: false,
        form_create_state: false,
        form_obj: null,

        virt_is_loading: false,
        virt_operations_items: [],

        operations_is_loading: false,
        operations_items: [],
    }),
    mounted() {
        this.fetchVirt();
        this.fetchOperations();
    },
    methods: {
        fetchVirt() {
            let self = this;
            self.virt_is_loading = true;
            axios.get('/api/operations/virtual_by_car', {
                params: {
                    car_id: this.car_id,
                    per_page: 100,
                },
            })
                .then(response => {
                    self.virt_operations_items = response.data.data;
                    self.virt_is_loading = false;
                });
        },
        fetchOperations() {
            let self = this;
            let operations = [];
            self.operations_is_loading = true;
            let urls = [
                '/api/operations/cash',
                '/api/operations/bank',
                '/api/operations/cars',
            ];
            let requests = urls.map(url => axios.get(url, {
                params: {
                    car_id: this.car_id,
                    per_page: 100,
                }
            }));

            Promise.all(requests)
                .then(responses => {
                    responses.forEach(res => {
                        operations = operations.concat(res.data.data);
                    })
                    self.operations_items = _.sortBy(operations, ['document_date', 'id']).reverse();
                    self.operations_is_loading = false;
                });
        },
        deleteVirtualOperation(id) {
            let self = this;
            self.virt_is_loading = true;
            axios.delete('/api/operations/', {
                params: {ids: [id]},
            })
                .then(response => {
                    self.virt_is_loading = false
                    this.fetchVirt();
                });
        },
        showEdit(id) {
            this.form_obj = _.find(this.virt_operations_items, {id: id});
            this.form_edit_id = id;
            this.form_edit_state = true;
        },
        showCreate() {
            this.form_obj = {
                platform_id: this.car_platform_id,
                car_id: this.car_id,
            };

            this.form_create_state = true;
        },
        onCreated(data) {
            this.form_create_state = false;
            // this.virt_operations.push(data);
            this.fetchVirt();
        },
        onUpdated(data) {
            this.form_edit_state = false;
            this.fetchVirt();
        }
    },
    computed: {
        virt_operations() {
            return _.map(this.virt_operations_items, item => {
                let category = OperationCategoryData.getById(item.category);
                return {
                    id: item.id,
                    amount: item.amount,
                    category: category ? category.name : null,
                    creator_name: item.creator.name,
                    created_at: moment(item.created_at).format("DD.MM.YYYY HH:mm:ss"),
                    comment: item.comment,
                    platform_id: item.platform_id,
                };
            });
        },
        operations() {
            return _.map(this.operations_items, item => {
                let i = _.clone(item);
                let category = OperationCategoryData.getById(item.category);
                let counteragent_name = item.counteragent ? this.$counteragentLabel(item.counteragent) : '';
                i.category = category ? category.name : null;
                i.document_date = moment(item.document_date).format("DD.MM.YYYY");
                i.counteragent_name = counteragent_name;

                return i;
            });
        }
    }
}
</script>

<style scoped>

</style>
